































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CostLabor, CostsApi, ValidationProblemDetails } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'costsApi'
  })
})
export default class DeleteCostLabor extends Vue {
  private api!: CostsApi;

  @Prop({ required: true })
  private labor!: CostLabor;

  private deleteLaborPopoverTippy = false;
  private isLoading = false;

  private async deleteLabor() {
    if (this.labor.workorderId && this.labor.costId) {
      this.isLoading = true;
      try {
        var costId = this.labor.costId;
        await this.api.deleteLaborById({ costId });
        this.isLoading = false;
        this.$emit('labor-deleted');
      } catch (error) {
        this.editorError(error);
      }
    }
    this.isLoading = false;
    this.deleteLaborPopoverTippy = false;
  }

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }

    if (vpd.errors) {
      alert(vpd.errors[''][0]);
    }
  }
}
